import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { JobSearchResultsColumnConfigurationComponent } from './job-search-results-column-configuration.component';
import { DialogLayoutModule } from '@fleet/ui';
import { MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { TitleCaseAndCleanPipeModule } from '@fleet/pipes';
import { MatSelectModule } from '@angular/material/select';
import { MatListModule } from '@angular/material/list';
import { ReactiveFormsModule } from '@angular/forms';

@NgModule({
  declarations: [JobSearchResultsColumnConfigurationComponent],
  imports: [
    CommonModule,
    DialogLayoutModule,
    MatDialogModule,
    MatButtonModule,
    MatCheckboxModule,
    TitleCaseAndCleanPipeModule,
    MatSelectModule,
    MatListModule,
    ReactiveFormsModule,
  ],
  exports: [JobSearchResultsColumnConfigurationComponent],
})
export class JobSearchResultsColumnConfigurationModule {}
